import StateTabs from './StateTabs';

export default StateTabs;
